import { render } from "./PortfolioSpokeNav.vue?vue&type=template&id=6aa398ec&scoped=true"
import script from "./PortfolioSpokeNav.vue?vue&type=script&lang=js"
export * from "./PortfolioSpokeNav.vue?vue&type=script&lang=js"

import "./PortfolioSpokeNav.vue?vue&type=style&index=0&id=6aa398ec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa398ec"]])

export default __exports__